import { render } from "./RequestBrochureForm.vue?vue&type=template&id=43200234"
import script from "./RequestBrochureForm.vue?vue&type=script&lang=js"
export * from "./RequestBrochureForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__